import { render } from "./index.vue?vue&type=template&id=00cb8701&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=00cb8701&lang=scss&scoped=true"

import exportComponent from "D:\\McToWebsite\\www\\CustomerWork\\GxTheater\\OfficialWebsite\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cb8701"]])

export default __exports__